export const routes = [
  ...require('./service-request/routes').routes,
  ...require('./representative/routes').routes,
  ...require('./service-order-attendant/routes').routes,
  ...require('./route-detailing/routes').routes,
  ...require('./zendesk/routes').routes,
  ...require('./integration-latis/routes').routes,
  ...require('./invoice-report/routes').routes,
  ...require('./invoice-received-competence/routes').routes,
  ...require('./invoice-exempt-cancelled/routes').routes,
  ...require('./service-report/routes').routes,
  ...require('./analyze-invoice-settlement/routes').routes,
  ...require('./audit-report/routes').routes,
  ...require('./messaging/routes').routes
]
